var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"white pl-5 pr-5 pt-4 pb-4 d-flex",attrs:{"app":""}},[_c('v-toolbar-title',{staticClass:"text-h4 font-weight-bold"},[_vm._v(" "+_vm._s(this.title.toUpperCase())+" ")]),_c('v-spacer'),_vm._t("search"),_vm._t("actions")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }